import {
    SessionPayload,
    SessionPresentation,
} from '~/backend/connector-api/connector-schemas';
import { Image3D } from '~/domain/patient/image3d';

/**
 * The session's context when it may stand in for the propagation source:
 * while no image is shown, or while the session's own image is. Otherwise
 * undefined, so the session's structure set is never paired with another
 * image.
 */
export function sessionContextAsSource(
    session: SessionPresentation | undefined,
    primaryImage: Image3D | undefined
): SessionPayload | undefined {
    const payload = session?.payload;
    if (
        primaryImage &&
        primaryImage.seriesUid !== payload?.context_image?.series_instance_uid
    ) {
        return undefined;
    }
    return payload;
}
